import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BlueImage from "../../assets/images/blue.jpeg";

import LastNewsImage1 from "../../assets/images/Home Page/lastNews3.jpg";
import LastNewsImage2 from "../../assets/images/Home Page/lastNews2.jpg";
import LastNewsImage3 from "../../assets/images/Home Page/lastNews1.jpg";
import LastNewsImage4 from "../../assets/images/Home Page/lastNews4.jpg";

const NewsData = [
  {
    id: 1,
    image: LastNewsImage1,
    title: "خبر 1",
    Link: "#",
  },
  {
    id: 2,
    image: LastNewsImage2,
    title: "خبر 2",
    Link: "#",
  },
  {
    id: 3,
    image: LastNewsImage3,
    title: "خبر 3",
    Link: "#",
  },
  {
    id: 4,
    image: LastNewsImage4,
    title: "خبر 4",
    Link: "#",
  },
];
const LastNewsComp = () => {
  return (
    <React.Fragment>
      <h2
        className="text-center "
        style={{
          color: "var(--primary-color)",
        }}
      >
        التصريحات الصحفية واللقاءات
        <i className="fas fa-newspaper"></i>
      </h2>

      <Row className="d-flex my-4 justify-content-around">
        {NewsData.map((item, index) => {
          return (
            <Col
              className="grid-item my-2"
              key={index}
              xs={12}
              md={index === 0 || index === 3 ? 7 : 4}
              style={{
                height: "300px",
                position: "relative",
              }}
            >
              <div
                className="News__img"
                style={{
                  height: "100%",
                  width: "100%",
                  position: "absolute",
                  top: "0",
                  left: "0",
                  zIndex: "-1",
                }}
              >
                <img
                  src={item.image}
                  alt="Maged Bannar"
                  className="img-fluid"
                  style={{
                    borderRadius: "10px",
                    height: "100%",
                    width: "100%",
                  }}
                />
              </div>
              <div className="overflow-hidden News__text ">
                <div className="h-100 d-flex flex-column  align-items-center  justify-content-center text-white p-3">
                  <h3 className="py-4 px-3">{item.title}</h3>
                  <button className="btn btn-outline-light">
                    اقرأ المزيد <i className="fas fa-arrow-left"></i>
                  </button>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </React.Fragment>
  );
};

export default LastNewsComp;
